<template>
  <div class="auth-panel">
    <h1 class="card-title">Sign in</h1>
    <p class="card-hint">Watch every vessel's position, fuel and performance as it happens.</p>
    <LoginForm @onSuccess="onSuccess" @onFailure="onFailure" />
  </div>
</template>

<script>
import LoginForm from '@/components/auth/LoginForm';
import { OPENING_KEY } from '@/util/auth/authIntro';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  inject: {
    authStage: { default: null },
  },
  methods: {
    async onSuccess() {
      await this.$store.dispatch('auth/getUser');
      try {
        sessionStorage.setItem(OPENING_KEY, '1');
      } catch (error) { /* mode privat */ }
      await this.$router.push({ name: 'CompanyActiveSelection' });
    },
    onFailure() {
      if (this.authStage) this.authStage.pulse('error');
    },
  },
};
</script>
